import { ConnectionPointConfiguration } from './conectionPoint.configuration';
import { WidgetBase, IWidgetConfiguration } from '../../widgets';
import { Helper } from '../../common';

export class ConnectionPointWidget extends WidgetBase {
    baseType = 'connectionPoint';
    col = 0;
    configuration: ConnectionPointConfiguration;
    guid: string;
    hasExtendedProperties = false;
    highlights = ['A connection point'];
    icon = 'fa-database';
    name = 'Connection point';
    row = 0;
    sizeX = 3;
    sizeY = 4;
    type = 'connectionPoint';

    constructor(private _$q: angular.IQService,
        private config?: IWidgetConfiguration) {

        super();

        this.setConfiguration(config);
        this.guid = Helper.getGuid();
        this.configuration = new ConnectionPointConfiguration();
    }

    readData(actualBeginDate?, actualEndDate?): angular.IPromise<any> {
        const self = this;
        const defered = self._$q.defer();
        defered.resolve();
        return defered.promise;
    }

    canDelete() {
        return !this.configuration.isDefault && !this.configuration.hasTags;
    }
}